module.exports = __webpack_public_path__ + "static/img/kehu-04.0bde7929.png";